module.exports = [{"name":"香港","cityList":["中西區","東區","南區","灣仔區"]},{"name":"九龍半島","cityList":["九龍城區","觀塘區","深水埗區","黃大仙區","油尖旺區"]},{"name":"新界島","cityList":["離島區","葵青區","北區","西貢區","沙田區","大埔區","荃灣區","屯門區","元朗區"]}]


//////////////////
// WEBPACK FOOTER
// ./src/common/json/HONGKONG_hk.json
// module id = m8WL
// module chunks = 1